import { QuestionMarkCircleIcon } from "@heroicons/react/16/solid";
import * as Icons from "@heroicons/react/24/solid";
const iconMap = Icons;
export const IconRenderer = ({ iconName }) => {
  const Icon = iconMap[iconName] || QuestionMarkCircleIcon;
  return <Icon className="w-5 h-5" />;
};